const renderedPhotosTemplate = require('templates/widgets/scrollable/photos.hbs');
const renderedIndexTemplate = require('templates/widgets/scrollable/index.hbs');

if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }


const PER_PAGE = 20;
const MAX_PHOTOS_TO_SHOW = 400;
const DEFAULTS = {
  size: 'large',
  maxPhotos: 400
};

L2H.ScrollableWidget = class ScrollableWidget extends L2H.Widget {
  constructor($container, photosURL, options) {
    super(...arguments);
    this.$container = $container;
    this.photosURL = photosURL;
    this.per = options.per || PER_PAGE;
    this.fetchingPhotos = false;
    this.widgetSize = options.size || DEFAULTS.size;
    this.nextPage = 1;
    this.photos = [];
    this.maxPhotos = options.max || DEFAULTS.maxPhotos;

    this.renderIndex();

    this.modalView = new L2H.PhotoModalView(this.$container, 'scrollable-widget', this.fetchPhotos.bind(this), options);
    this.modalView.setPhotos(this.photos);

    this.$scrollable = this.$container.find(".l2h-scrollable");
    this.$scrollableContainer = this.$scrollable.find('.l2h-photos');

    const self = this;
    this.fetchPhotos().done(function() {
      self.bindEvents();
      self.$container.addClass('widget-loaded');
      self.disableLeftScroller();
    });

    if (options.sd) {
      this.autoScrollDelay = options.sd * 1000;
      this.enableAutoScroll();
    }

    if (L2H.debug) {
      L2H.currentWidget = this;
    }
  }

  fetchPhotos() {
    const deferred = new $.Deferred();

    if (this.fetchingPhotos) {
      deferred.resolve();
      return deferred;
    }

    if (this.nextPage === null) {
      deferred.resolve();
      return deferred;
    }

    this.fetchingPhotos = true;

    const self = this;
    $.ajax({
      url: this.photosURL,
      data: {page: this.nextPage, per: this.per},
      dataType: "jsonp"
    }).done(function(data) {
      var numberOfPhotosToKeep = Math.max(0, self.maxPhotos - self.photos.length);
      var photosToAdd = []

      if (numberOfPhotosToKeep >= data.photos.length) {
        numberOfPhotosToKeep = data.photos.length;
      }

      photosToAdd = data.photos.slice(0,numberOfPhotosToKeep);

      $.merge(self.photos, photosToAdd);
      self.nextPage = data.meta.nextPage;
      self.appendPhotos(photosToAdd);


      let brokenPhotoChecker = new L2H.BrokenPhotoCheck();
      brokenPhotoChecker.call(photosToAdd);

      self.fetchingPhotos = false;
      self.totalCount = Math.min(data.meta.totalCount, self.maxPhotos);
      return deferred.resolve();
    });

    return deferred;
  }

  appendPhotos(photos) {
    const renderedPhotos = renderedPhotosTemplate({photos, preferences: this.preferences});
    return this.$container.find('.l2h-photos').append(renderedPhotos);
  }

  renderIndex() {
    const renderedIndex = renderedIndexTemplate({photos: this.photos, widgetSize: this.widgetSize, preferences: this.preferences});
    return this.$container.html(renderedIndex);
  }

  bindEvents() {
    const self = this;
    this.$container
      .on('click', '.l2h-arrow-right', function(e) {
        e.preventDefault();
        return self.scroll('right');
      }).on('click', '.l2h-arrow-left', function(e) {
        e.preventDefault();
        return self.scroll('left');
      }).on('click', function(e) {
        self.disableAutoScroll();
        // without this then default link behaviour is prevented on all clicks
        return true;
      });

    this.bindScrollable();
  }

  autoScroll() {
    if (!this.autoScrollEnabled) { return; }

    if ((this.$scrollableContainer[0].scrollLeft > 0) && ((this.$scrollableContainer[0].scrollWidth - this.$scrollableContainer.innerWidth()) === this.$scrollableContainer.scrollLeft())) {
      // we've reached the right, lets go back to the start
      this.scrollTo(0);
    }

    const self = this;
    setTimeout(function() {
      if (self.autoScrollEnabled) { self.scroll('right'); }
      return self.autoScroll();
    }, this.autoScrollDelay);
  }

  enableAutoScroll() {
    this.autoScrollEnabled = true;
    return this.autoScroll();
  }

  disableAutoScroll() {
    return this.autoScrollEnabled = false;
  }

  disableRightScroller() {
    this.$container.find('.l2h-arrow-right').addClass('l2h-disabled');
  }

  enableRightScroller() {
    this.$container.find('.l2h-arrow-right').removeClass('l2h-disabled');
  }

  disableLeftScroller() {
    this.$container.find('.l2h-arrow-left').addClass('l2h-disabled');
  }

  enableLeftScroller() {
    this.$container.find('.l2h-arrow-left').removeClass('l2h-disabled');
  }

  bindScrollable() {
    const self = this;

    this.$scrollableContainer.on('scroll', $.throttle(200, function() {
      const $scrollableContainer = $(this);
      const photoWidth = self.scrollWidth();
      const scrollLeft = $scrollableContainer.scrollLeft();

      const distanceToRightEdge = $scrollableContainer[0].scrollWidth - (scrollLeft + $scrollableContainer.innerWidth());

      if (scrollLeft === 0) {
        self.disableLeftScroller();
      } else {
        self.enableLeftScroller();
      }

      if (self.photos.length === self.totalCount) {
        if (distanceToRightEdge <= 0) {
          self.disableRightScroller();
        } else {
          self.enableRightScroller();
        }
      } else {
        if (distanceToRightEdge <= 0) {
          if (L2H.debug) { console.log("L2H DEBUG: fetching next batch of photos"); }
          self.fetchPhotos();
        }
      }
    }));
  }

  unbindScrollable() {
    return this.$scrollableContainer.off('scroll');
  }

  scrollWidth() {
    if (this.photos.length < 2) { return; }

    const photo1 = this.$container.find('.l2h-photowrap:eq(1)');
    const photo2 = this.$container.find('.l2h-photowrap:eq(2)');

    return photo2.offset().left - photo1.offset().left;
  }

  numberOfPhotosThatCanFit() {
    if (this.photos.length < 2) { return; }

    const photoWidth = this.$container.find('.l2h-photowrap:eq(1)').width();
    const marginWidth = this.scrollWidth() - photoWidth;

    const innerWidth = this.$scrollableContainer.innerWidth();
    return Math.floor((1.0*(innerWidth + (2.0*marginWidth)))/(photoWidth + marginWidth));
  }

  scrollTo(photoIdx) {
    if (L2H.debug) { console.log(`L2H DEBUG: scrolling to index: ${photoIdx}`); }
    if (this.photos.length < 2) { return; }
    if (photoIdx < 0) { return; }

    return this.$scrollableContainer.animate(
      {scrollLeft: this.scrollWidth() * photoIdx}
      , 300);
  }

  scroll(direction) {
    let num = this.numberOfPhotosThatCanFit();
    if (direction === 'left') {
      num = num * -1;
    }

    let scrollToIdx = this.closestScrollIndex() + num;
    if (scrollToIdx < 0) { scrollToIdx = 0; }


    this.scrollTo(scrollToIdx);
  }

  closestScrollIndex() {
    const offset = this.$scrollableContainer.scrollLeft();
    return Math.ceil((1.0*offset)/this.scrollWidth());
  }
};
